// extracted by mini-css-extract-plugin
export var redoItem = "_nb-1";
export var redoTrigger = "_nb-0";